import React, { Component } from "react";

class TypedText extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
      text: "",
      deleting: false,
    };

    this.timer = null;
  }

  componentDidMount() {
    this.startTyping();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      this.resetTyping();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  resetTyping = () => {
    clearTimeout(this.timer);

    this.setState(
      {
        index: 0,
        text: "",
        deleting: false,
      },
      this.startTyping
    );
  };

  startTyping = () => {
    const texts = this.props.texts || [];

    if (!texts.length) return;

    const currentText = texts[this.state.index];

    if (!this.state.deleting) {
      const nextText = currentText.substring(
        0,
        this.state.text.length + 1
      );

      this.setState(
        {
          text: nextText,
        },
        () => {
          if (nextText === currentText) {
            this.timer = setTimeout(() => {
              this.setState({
                deleting: true,
              });
              this.startTyping();
            }, 1500);
          } else {
            this.timer = setTimeout(this.startTyping, 80);
          }
        }
      );
    } else {
      const nextText = currentText.substring(
        0,
        this.state.text.length - 1
      );

      this.setState(
        {
          text: nextText,
        },
        () => {
          if (nextText === "") {
            const nextIndex =
              (this.state.index + 1) % texts.length;

            this.setState(
              {
                index: nextIndex,
                deleting: false,
              },
              this.startTyping
            );
          } else {
            this.timer = setTimeout(this.startTyping, 40);
          }
        }
      );
    }
  };

  render() {
    return (
       <span className="typed-word">
      {this.state.text}
    </span>
    );
  }
}

export default TypedText;